import { datadogRum } from '@datadog/browser-rum'

function isRumInitialized() {
  if (typeof datadogRum.getInitConfiguration === 'function') {
    const cfg = datadogRum.getInitConfiguration()
    if (cfg != null) {
      return true
    }
  }
  return (
    typeof datadogRum.getInternalContext === 'function' &&
    Boolean(datadogRum.getInternalContext())
  )
}

function trackDatadogAction(eventName, eventData) {
  if (typeof datadogRum.addAction !== 'function') {
    return
  }

  if (!isRumInitialized()) {
    return
  }

  datadogRum.addAction(eventName, eventData)
}

function trackEvent(eventName, eventData) {
  trackDatadogAction(eventName, eventData)
}

// Exported functions
export function focusLocation(locationId, partnerId) {
  trackEvent('locationFocused', { locationId, partnerId })
}

export function search(address, partnerId) {
  trackEvent('searchStarted', { address, partnerId })
}

export function inteliblyRequestOpened(locationId, partnerId) {
  trackEvent('inteliblyRequestOpened', { locationId, partnerId })
}

export function scheduleConnectOpened(locationId, partnerId) {
  trackEvent('scheduleConnectOpened', { locationId, partnerId })
}

export function manualBookingOpened(locationId, partnerId) {
  trackEvent('manualBookingOpened', { locationId, partnerId })
}

export function dolphinBookingOpened(locationId, partnerId) {
  trackEvent('dolphinBookingOpened', { locationId, partnerId })
}

export const pushAnalytics = (path, partnerId) => {
  let page_path = path
  if (partnerId) {
    page_path = `/partners/${partnerId}${page_path}`
  }

  if (typeof datadogRum.startView !== 'function' || !isRumInitialized()) {
    return
  }

  datadogRum.startView({ name: page_path })
}
